/**
 * 슬롯 정책 API 타입 정의
 */

// ===== DTO (API 응답) =====

export interface SlotDayDto {
    dayOfWeek: number;   // 1=월, 2=화, 3=수, 4=목, 5=금, 6=토, 7=일
    startTime: string;   // HH:MM
    endTime: string;     // HH:MM
    targetCnt: string;   // 목표 건수
}

export interface SlotDto {
    seqNo: number | null;
    slotOrder: number;
    slotName: string;
    days: SlotDayDto[];
    useYn: string;
}

export interface SlotPolicyDto {
    seqNo: number;
    policyName: string;
    applyStartDate: string | null;
    requiredSlotCnt: number | null;
    acceptanceRate: number | null;
    useYn: string;
    standardAreas: string[];
    slots: SlotDto[];
}

export interface GetSlotPoliciesResponseDto {
    totalCount: number;
    policies: SlotPolicyDto[];
}

// ===== 공통코드 (SLOTINFO 기본값) =====

export interface SlotInfoCodeDto {
    comCode: string;
    comCdName: string;
    val1: string | null;
    val2: string | null;
    val3: string | null;
    val4: string | null;
    val5: string | null;
    val6: string | null;
    val7: string | null;
}

export interface GetSlotInfoDefaultsResponseDto {
    totalCount: number;
    codes: SlotInfoCodeDto[];
}

// ===== 요청 =====

export interface SlotDayItemRequest {
    dayOfWeek: number;
    startTime: string;
    endTime: string;
    targetCnt: string;
}

export interface SlotItemRequest {
    seqNo: number | null;
    slotOrder: number;
    slotName: string;
    days: SlotDayItemRequest[];
}

export interface SaveSlotPolicyRequest {
    seqNo: number | null;
    policyName: string;
    applyStartDate: string;
    requiredSlotCnt: number | null;
    acceptanceRate: number | null;
    standardAreas: string[];
    slots: SlotItemRequest[];
    userId: string;
}

// ===== 폼 상태 (UI 전용) =====

export interface SlotDayItemForm {
    dayOfWeek: number;
    startTime: string;
    endTime: string;
    targetCnt: string;
}

export interface SlotItemForm {
    seqNo: number | null;
    slotName: string;
    days: SlotDayItemForm[];
}

export interface SlotPolicyForm {
    seqNo: number | null;
    policyName: string;
    applyStartDate: string;
    requiredSlotCnt: string;
    acceptanceRate: string;
    selectedStandardAreas: string[];
    useYn: string;
    slots: SlotItemForm[];
    isDefault: boolean;
}

export const DAY_LABELS = ['월', '화', '수', '목', '금', '토', '일'] as const;

const DEFAULT_DAYS: SlotDayItemForm[] = [1, 2, 3, 4, 5, 6, 7].map(dow => ({
    dayOfWeek: dow,
    startTime: '',
    endTime: '',
    targetCnt: '',
}));

export const DEFAULT_SLOT_ITEM: SlotItemForm = {
    seqNo: null,
    slotName: '',
    days: DEFAULT_DAYS.map(d => ({ ...d })),
};

export const DEFAULT_FORM: SlotPolicyForm = {
    seqNo: null,
    policyName: '',
    applyStartDate: '',
    requiredSlotCnt: '',
    acceptanceRate: '',
    selectedStandardAreas: [],
    useYn: 'Y',
    slots: [{ ...DEFAULT_SLOT_ITEM, days: DEFAULT_DAYS.map(d => ({ ...d })) }],
    isDefault: false,
};
